import DataSourceConfig from '../Config/DataSourceConfig';
import SystemDataService from '../Services/SystemDataService';
import { CategoryEntity } from '../Entities';

// NOTE: keep everything above the first `export` free of Entity references, // scripts/seed-content-to-s3.js evaluates that part in a sandbox to extract
// CategoryData.

// Category ids/slugs mirror the programs in services-data.js (categoryId), and
// each category's image matches its program's card image so the programs pages
// and category pages stay visually consistent.
const CAT_IMAGES = {
    'category-one': '/placeholder.svg',
    'category-two': '/placeholder.svg',
    'category-three': '/placeholder.svg',
};

// ── Category Registry ─────────────────────────────────────────────────────────
const PROGRAM_CATEGORIES = [
    {
        id: 'category-one',
        parentId: null,
        slug: 'category-one',
        status: true,
        popular: true,
        name: 'Category One',
        title: 'Category One',
        subtitle: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
        description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
        image: CAT_IMAGES['category-one'],
        media: CAT_IMAGES['category-one'],
        ctaText: 'Learn More',
        items: ['Item One', 'Item Two', 'Item Three'],
        seo: {
            title: 'Category One | Your Business',
            description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
            keywords: 'keyword one, keyword two, keyword three',
            image: CAT_IMAGES['category-one'],
        }
    },
    {
        id: 'category-two',
        parentId: null,
        slug: 'category-two',
        status: true,
        popular: true,
        name: 'Category Two',
        title: 'Category Two',
        subtitle: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
        description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
        image: CAT_IMAGES['category-two'],
        media: CAT_IMAGES['category-two'],
        ctaText: 'Learn More',
        items: ['Item One', 'Item Two', 'Item Three'],
        seo: {
            title: 'Category Two | Your Business',
            description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
            keywords: 'keyword one, keyword two, keyword three',
            image: '/placeholder.svg',
        }
    },
    {
        id: 'category-three',
        parentId: null,
        slug: 'category-three',
        status: true,
        popular: true,
        name: 'Category Three',
        title: 'Category Three',
        subtitle: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
        description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
        image: CAT_IMAGES['category-three'],
        media: CAT_IMAGES['category-three'],
        ctaText: 'Learn More',
        items: ['Item One', 'Item Two', 'Item Three'],
        seo: {
            title: 'Category Three | Your Business',
            description: 'Add your content here. This placeholder describes the section and can be replaced with your own copy.',
            keywords: 'keyword one, keyword two, keyword three',
            image: CAT_IMAGES['category-three'],
        }
    },
];

// Both language files carry the same content.
const CategoryData = {
    he: { categories: PROGRAM_CATEGORIES },
    en: { categories: PROGRAM_CATEGORIES },
};

// ── Public API ────────────────────────────────────────────────────────────────
const getLocalCategories = (language) => {
    const lang = language || localStorage.getItem('language') || 'he';
    return CategoryData[lang]?.categories || CategoryData.en.categories;
};

// Normalization / active-filter live on CategoryEntity.
export const getAllCategories = (language) => CategoryEntity.list(getLocalCategories(language));

export const getCategoriesData = async () => {
    const localCategories = CategoryEntity.list(getLocalCategories());

    if (DataSourceConfig.categories === 'local') {
        return localCategories;
    }

    try {
        const apiData = await SystemDataService.getCategories();
        if (apiData && Array.isArray(apiData) && apiData.length > 0) return CategoryEntity.list(apiData);
    } catch (err) {
        console.error('getCategoriesData: backend failed, using local data', err);
    }

    return localCategories;
};

export const isValidCategory = (slug) => {
    const allCategories = [
        ...CategoryData.en.categories,
        ...CategoryData.he.categories
    ];

    return allCategories.some(c => c.slug === slug);
};

export default getLocalCategories();
